import * as React from 'react';
import { useState } from 'react';
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner} from "react-bootstrap";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import * as yup from 'yup';
import * as formik from 'formik';
import atlasApi from "../utils/atlasapi";
import schemas from "../data/dataSchemas";
import Country from "../classes/Country";
import ColorPicker from "../components/ColorPicker";
import {Warning   } from "@phosphor-icons/react";

//
//{
//
//    "name":"Latesto O\u00dc",
//    "airtableId":"rec4iQSTveeQTJnJD",
//    "email":"rein.palipea@latesto.ee",
//    "phone":"+3725045647",
//    "address":", ",
//    "id":233,
//    "properties":[
//        {
//            "id":"13402:002:0400",
//            "status":"Ready to sign"
//        }
//    ],
//    "totalArea":6.44
//
//}



export interface diagProps {
	owner: object;
	onClose: (value: string) => void;
}

const { Formik } = formik;

class DialogOwner extends React.Component {

	
	constructor(props) {
		super(props);
		this.default = {firstName:'', lastName:'', companyName:'', identifier:'', zipcode:'', city:'', street:'', country:'', email:'', phone:'', propertyId:'', projectId:'', scenarioId:'', color:''};
		
		this.state = {
			validated: false,
			status: {sent:null, message:''},
			formType:'private',
			colorChange: false
		}
		
		//this.owner = schemas.owner.cast(this.props.setup.owner);
		
	}
	updateStatus(s){
		var x = {...this.state, ...s};
		this.setState(x);
		this.forceUpdate();
	}

	handleOnSave(data){
		if(this.props.setup.onSave)
			this.props.setup.onSave(data);
	};
	handleClose(data){
		this.props.onClose(data);
		this.updateStatus({status:{sent:null, message:'', owner:null}});
	};
	handleOnShow(e){
		
		if(this.props.setup.owner  && this.props.setup.owner.companyName)
			this.updateStatus({formType:'company'})
		
	};

	handleSubmit(data){
		
		data = {...this.default, ...data};
		
		this.updateStatus({status:{sent:false, success:false, message:'Saving...'}});

		var userToPost = (({ id, firstName, lastName, companyName, identifier, zipcode, city, country, street, email, phone, propertyId, projectId, scenarioId, color }) => ({ id, firstName, lastName, companyName, identifier, zipcode, city, country, street, email, phone, propertyId, projectId, scenarioId, color }))(data);
		atlasApi.updateOwner(userToPost).then((data)=>{
			if(data.updateSuccess || data.landownerId){   //update user response format || insert user response format
				this.updateStatus({status:{sent:true, success:true, message:'Owner has been '+(userToPost.id ? 'updated' : 'added')}});
				if(!userToPost.id){
					userToPost.id = data.landownerId;
					userToPost.totalArea = 0;
					userToPost.turbines = 0;
					userToPost.dialogs = [];
					userToPost.property_total_area = [];
				}
				else{
					userToPost = {...this.props.setup.owner, ...userToPost};
				}
				userToPost.fullName = userToPost.firstName+' '+userToPost.lastName;
				if(this.handleOnSave)
					this.handleOnSave(userToPost);
				
				setTimeout(()=>this.handleClose(userToPost), 1000);
			}
			else
				this.updateStatus({status:{sent:true, success:false, message:'Error saving Owner'}});
		}).catch((e)=>{
			this.updateStatus({status:{sent:true, success:false, message:'Error saving Owner'}});
		});
	};


	render() {
		if(!this.props.setup.owner)
			return;
		return (
			<Modal show={this.props.setup.open} className="dialog-owner" onHide={(e)=>this.handleClose(e)} onShow={(e)=>this.handleOnShow(e)} centered>
				<Modal.Header closeButton>
					<Modal.Title>{this.props.setup.owner.id ? 'Edit' : 'Create'} owner</Modal.Title>
				</Modal.Header>
				<Formik validationSchema={schemas.owner} onSubmit={this.handleSubmit.bind(this)} initialValues={this.props.setup.owner}>	
					{({ handleSubmit, handleChange, values, touched, errors, isValid, dirty,setFieldValue }) => (
						<Form noValidate onSubmit={handleSubmit}>
							<input type="hidden" name="id" value={values.id ? values.id : ''} />
							<input type="hidden" name="propertyId" value={values.propertyId} />
							<input type="hidden" name="projectId" value={values.projectId} />
							<input type="hidden" name="scenarioId" value={values.scenarioId} />
							{this.state.status.sent === null ? (
								<React.Fragment>
									<Modal.Body>
									
										<Row className="mb-3">
											<Form.Group as={Col} md="6" controlId="validationFormik01">
												
												     <Form.Check key="1" type="radio" id="type-private" checked={this.state.formType == 'private' } name="type" value="private" onChange={(e)=>{this.updateStatus({formType:e.target.value})}} label="Private" />
													 <Form.Check key="2" type="radio" id="type-company" checked={this.state.formType == 'company' } name="type" value="company" onChange={(e)=>{this.updateStatus({formType:e.target.value})}} label="Company" />
											</Form.Group>
											
											<Form.Group as={Col} md="6" controlId="validationFormik099">
												<Form.Label>Landowner color</Form.Label>
												<ColorPicker onChange={(color)=>{this.updateStatus({colorChange:true}); setFieldValue("color", color) }} color={values.color} />
											</Form.Group>
											
										</Row>
										{
										this.state.colorChange && 
										<Row className="mb-3">
											<Col xs="1" className="text-danger pr-0 w-5">
												<Warning size={16} />
											</Col>
											<Col xs="11" className="ps-2">
												<b>Note:</b> Changing the landowner color is site-wide and will affect projects with this landowner.
											</Col>
										</Row>
										}
										
										
										<Row className="mb-1">
											<Col><h5>About the owner</h5></Col>
										</Row>
										
										{this.state.formType=='private' &&
										<Row className="mb-3">
											<Form.Group as={Col} md="6" controlId="validationFormik01">
												<Form.Label>First Name</Form.Label>
												<Form.Control type="text" name="firstName" placeholder="First Name" value={values.firstName } onChange={handleChange} isValid={touched.firstName && !errors.firstName} isInvalid={errors.firstName}/>
												<Form.Control.Feedback type="invalid">
													Please provide a valid  first name.
												</Form.Control.Feedback>
											</Form.Group>
											<Form.Group as={Col} md="6" controlId="validationFormik00">
												<Form.Label>Last Name</Form.Label>
												<Form.Control type="text" name="lastName" placeholder="Last Name" value={values.lastName } onChange={handleChange} isValid={touched.lastName && !errors.lastName} isInvalid={errors.lastName}/>
												<Form.Control.Feedback type="invalid">
													Please provide a valid last name.
												</Form.Control.Feedback>
											</Form.Group>
										</Row>
										}
										{this.state.formType=='company' &&
										<Row className="mb-3">
											<Form.Group as={Col} md="12" controlId="validationFormik01">
												<Form.Label>Company name</Form.Label>
												<Form.Control type="text" name="companyName" placeholder="Company name" value={values.companyName } onChange={handleChange} isValid={touched.companyName && !errors.companyName} isInvalid={errors.companyName}/>
												<Form.Control.Feedback type="invalid">
													Please provide a valid  company name.
												</Form.Control.Feedback>
											</Form.Group>
										</Row>
										}
										<Row className="mb-3">
											<Form.Group as={Col} md="12" controlId="validationFormik03">
												<Form.Label>Email</Form.Label>
												<Form.Control type="text" name="email" placeholder="Email"   value={values.email} onChange={handleChange} isValid={touched.email && !errors.email} isInvalid={errors.email}/>
												<Form.Control.Feedback type="invalid">
													Please provide a valid email.
												</Form.Control.Feedback>
											</Form.Group>
										</Row>
										<Row className="mb-3">
											<Form.Group as={Col} md="12" controlId="validationFormik04">
												<Form.Label>Phone</Form.Label>
												<Form.Control type="text" name="phone" placeholder="Phone"   value={values.phone} onChange={handleChange} isValid={touched.phone && !errors.phone} isInvalid={errors.phone}/>
												<Form.Control.Feedback type="invalid">
													Please provide a valid phone number.
												</Form.Control.Feedback>
											</Form.Group>
										</Row>
										<Row className="mb-3">
											<Form.Group as={Col} md="12" controlId="validationFormik05">
												<Form.Label>Address</Form.Label>
												<Form.Control type="text" name="street" placeholder="Address"   value={values.street} onChange={handleChange} isValid={touched.street && !errors.street} isInvalid={ errors.street}/>
												<Form.Control.Feedback type="invalid">
													Please provide a valid address.
												</Form.Control.Feedback>
											</Form.Group>
										
										</Row>
										<Row className="mb-3">
											<Form.Group as={Col} md="3" controlId="validationFormik06">
												<Form.Label>Zip Code</Form.Label>
												<Form.Control type="text" name="zipcode" placeholder="Zip Code"   value={values.zipcode} onChange={handleChange} isValid={touched.zipcode && !errors.zipcode} isInvalid={errors.zipcode}/>
												<Form.Control.Feedback type="invalid">
													Please provide a valid zip code.
												</Form.Control.Feedback>
											</Form.Group>
											<Form.Group as={Col} md="9" controlId="validationFormik07">
												<Form.Label>City</Form.Label>
												<Form.Control type="text" name="city" placeholder="Location"   value={values.city} onChange={handleChange} isValid={touched.city && !errors.city} isInvalid={ errors.city}/>
												<Form.Control.Feedback type="invalid">
													Please provide a valid city.
												</Form.Control.Feedback>
											</Form.Group>
										</Row>
										<Row className="mb-3">
											<Form.Group as={Col} md="12" controlId="validationFormik05">
												<Form.Label>Country</Form.Label>
												    <Form.Select name="country" aria-label="Select country" defaultValue={values.country} onChange={(e) => setFieldValue("country", e.target.value)} isValid={touched.country && !errors.country} isInvalid={ errors.country}>
													
														<option value="">Select country</option>
														{Country.options.map((a)=>{return <option value={a.value}>{a.label}</option>})}

													</Form.Select>
												<Form.Control.Feedback type="invalid">
													Please provide a valid country.
												</Form.Control.Feedback>
											</Form.Group>
										</Row>
									</Modal.Body>
									<Modal.Footer>
										<Button className="me-auto" variant="outline-primary" onClick={(e)=>this.handleClose()}>Close</Button>
										<Button variant="primary" type="submit">Save Owner</Button>
									</Modal.Footer>
								</React.Fragment>
							) : (
							<Modal.Body>
								<Row className="mb-3 dialog-feedback">
									<Col xs="12" className="dialog-feedback-icon text-center">
										{
										this.state.status.sent ?
											(this.state.status.success ? 
												(<i className="ri-checkbox-circle-line text-success"></i>)
												:
												(<i className="ri-error-warning-line text-warning"></i>)
											)
											:
											(<Spinner animation="border" variant="info" className="mt-5" />)
										}
									</Col>
									<Col xs="12" className="dialog-feedback-text mb-5">
										{this.state.status.message}
									</Col>
								</Row>
							</Modal.Body>	
							)}
						</Form>
					)}	
				</Formik>
			</Modal>
		);
	}
}

export default DialogOwner;